export type Plan = {
  type: 'standart-month' | 'standart-year' | 'professional-month' | 'professional-year';
  name: string;
  description: string;
  regularPrice: number;
  subTotal: number;
  discountCodeProfit: any;
  totalPrice: number;
  regularPriceOnMonth: number;
  isYearly: boolean;
  yearProfitLabel: any;
  options: {
    "title": string,
    "tooltip": string,
  }[]
};

export type BasikPlan = {
  options: {
    "title": string,
    "tooltip": string,
  }[]
}

export interface TokenPlan {
  type: string;
  name: string;
  regularPrice: number;
  subTotal: number;
  discountCodeProfit: any;
  totalPrice: number;
}

export type PlanKey =
  | 'standart-month'
  | 'standart-year'
  | 'professional-month'
  | 'professional-year'
  | 'tokens';
export interface PlansList {
  'standart-month': Plan;
  'standart-year': Plan;
  'professional-month': Plan;
  'professional-year': Plan;
  'basic': BasikPlan,
  tokens: TokenPlan;
}
